module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Inter Invest","short_name":"Inter Invest","start_url":"/","background_color":"#e5e5e5","theme_color":"#EB7000","display":"minimal-ui","icon":"./src/assets/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4fba683eb4bc1ce9efdcd2a4aa16d925"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
